<div class="welcome-button flex-container">
    <div class="flex-item">
        <img src="/assets/icons/suggest_button.svg" />
    </div>
    <div class="flex-item">
        <h4>{{ title }}</h4>
        <div class="description">{{ description }}</div>
    </div>
</div>